<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Solicitação de Desconto</mat-card-title>
    </div>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-8">
    <mat-card class="card-style px-4 py-6">
      <div class="flex justify-between gap-4 mb-4">
        <div class="w-1/4"><b>tg cod:</b> {{ item.tg }}</div>
        <div class="w-1/4"><b>Evento:</b> {{ item.nomeEvento ?? '-' }}</div>
        <div class="w-1/4">
          <b>Período:</b> {{ item.dataEventoInicio }} - {{ item.dataEventoFim }}
        </div>
        <div class="w-1/4"></div>
      </div>
      <div class="flex justify-between gap-4 mb-4">
        <div class="w-1/4"><b>Cliente:</b> {{ item.nome }}</div>
        <div class="w-1/4">
          <b>Subcliente:</b> {{ item.subClienteNome ?? '-' }}
        </div>
        <div class="w-1/4">
          <b>Consultor Cliente:</b> {{ item.consultorComercialNome ?? '-' }}
        </div>
        <div class="w-1/4">
          <b>Consultor Comercial:</b> {{ item.consultorNome ?? '-' }}
        </div>
      </div>
    </mat-card>
    <div class="mt-6">
      @if (!loading) {
        <div class="tab-overflow">
          <table mat-table [dataSource]="rows" class="mat-elevation-z8">
            @for (column of columns; track column.keyColumn) {
              <ng-container matColumnDef="{{ column.keyColumn }}">
                <th mat-header-cell *matHeaderCellDef>
                  {{ column.description }}
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (column.keyColumn == 'action') {
                    <div class="flex justify-center items-center gap-3">
                      <mat-icon
                        class="btn-icon-outline"
                        fontIcon="route"
                        matTooltip="Itinerários"
                        (click)="viewItineraries(element)"
                      />
                      <mat-icon
                        class="btn-icon-outline"
                        fontIcon="sell"
                        matTooltip="Aplicar desconto"
                        (click)="applyDiscount(element)"
                      />
                    </div>
                  } @else if (column.keyColumn == 'location_OD') {
                    <b>Origem: </b>{{ element.origem }}<br />
                    <b>Destino: </b>{{ element.destino }}
                    @if (element.paradas?.length) {
                      <div class="mt-1 text-xs text-gray-600">
                        <b>Paradas ({{ element.paradas.length }}):</b>
                        @for (
                          p of element.paradas;
                          track p.id;
                          let i = $index
                        ) {
                          <div>
                            {{ i + 1 }}. {{ p.cidade
                            }}{{ p.cidade && p.estado ? ' - ' : '' }}{{ p.estado }}
                          </div>
                        }
                      </div>
                    }
                  } @else if (column.keyColumn == 'servico_TS') {
                    <b>Tipo: </b>{{ element.descricaoTipoServico }}<br />
                    <b>Serviço: </b>{{ element.descricaoServico }}
                  } @else if (column.keyColumn == 'vehicle_VM') {
                    <b>Tipo veículo: </b>{{ element.descricaoTipoVeiculo }}<br />
                    <b>Tipo motorista: </b>{{ element.descricaoTipoMotorista }}
                  } @else if (column.keyColumn == 'period_date') {
                    <b>Início: </b>{{ element.dataInicio }}<br />
                    <b>Final: </b>{{ element.dataFinal }}
                  } @else if (column.keyColumn == 'cost') {
                    {{ element.custoFormatado }}
                  } @else {
                    {{ element[column.key] }}
                  }
                </td>
              </ng-container>
            }
            <tr
              mat-header-row
              class="style-header"
              *matHeaderRowDef="displayedColumns"
            ></tr>
            <tr
              mat-row
              class="style-row"
              *matRowDef="let row; columns: displayedColumns"
            ></tr>
          </table>
          @if (rows.length === 0) {
            <h3 class="text-center mt-4">
              Nenhum item com desconto pendente nesta proposta.
            </h3>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</mat-card>
